var submitButton = document.querySelector(".cart__submit.cart__submit-control");
var acceptTermsCheckbox = document.querySelector(".cart__accept_terms_container input");
var termsLink = document.querySelector(".cart__accept_terms_container a");
var termsModal = $(".terms_modal_container");
var termsModalClose = document.querySelector(".terms_modal_close");

submitButton.setAttribute("disabled", "");
acceptTermsCheckbox.addEventListener("change", function(e) {
  if (e.target.checked) {
    submitButton.removeAttribute("disabled");
  } else {
    submitButton.setAttribute("disabled", "");
  }
});

termsLink.addEventListener("click", function(e) {
  OpenTermsModal();
});

termsModalClose.addEventListener("click", function() {
  CloseTermsModal();
});


function OpenTermsModal() {
  $("body").css("overflow", "hidden");
  termsModal.find(".terms_modal_inner").load("/25536299061/policies/terms-of-service.html");
  termsModal.removeClass("hidden");
}

function CloseTermsModal() {
  $("body").css("overflow", "auto");
  termsModal.addClass("hidden");
}